import { store, mutations } from '@/store';

// 与 TokenStoreFullscreen 共用:订单本地缓存 key 与 Token 商店后端
const TOKEN_STORE_API_BASE = 'https://wm.ktllq.cn/Token';
const TOKEN_STORE_ORDERS_KEY = 'aihelp_token_store_orders';
// 已自动导入过的订单号:用户在设置里删掉已购模型后不再被重新加回;清理浏览数据后会随之清空并重新导入
const IMPORTED_ORDERS_KEY = 'aihelp_token_store_imported';
const MIN_SYNC_INTERVAL_MS = 10 * 1000;

let lastSyncAt = 0;
let lastSyncToken = '';
let syncing = null;

const readJson = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (e) {
    return fallback;
  }
};

const writeJson = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // 存储不可用时只影响去重,不影响本次导入
  }
};

const mergeOrdersCache = (orders) => {
  const cached = readJson(TOKEN_STORE_ORDERS_KEY, []);
  const list = Array.isArray(cached) ? cached : [];
  orders.slice().reverse().forEach((order) => {
    const index = list.findIndex(item => item.orderNo === order.orderNo);
    if (index === -1) {
      list.unshift(order);
    } else {
      list[index] = { ...list[index], ...order, modelConfig: order.modelConfig || list[index].modelConfig };
    }
  });
  writeJson(TOKEN_STORE_ORDERS_KEY, list);
};

/**
 * 从云端拉取当前账号的 Token 商店订单,把已发货但本地还没有的模型加入模型列表,
 * 并切换到其中最新的一个。浏览器设置页里购买的模型由此进入 AI 面板。
 * @returns {Promise<object|null>} 新切换到的模型
 */
export function syncTokenStoreModels({ force = false } = {}) {
  const token = store.token || '';
  if (!token) return Promise.resolve(null);
  const now = Date.now();
  if (!force && token === lastSyncToken && now - lastSyncAt < MIN_SYNC_INTERVAL_MS) {
    return Promise.resolve(null);
  }
  if (syncing) return syncing;
  lastSyncAt = now;
  lastSyncToken = token;

  syncing = (async () => {
    try {
      const response = await fetch(`${TOKEN_STORE_API_BASE}/orders?token=${encodeURIComponent(token)}`);
      const result = await response.json();
      if (result.code !== 0 || !result.data) return null;
      const orders = Array.isArray(result.data.orders) ? result.data.orders : [];
      mergeOrdersCache(orders);

      const imported = new Set(readJson(IMPORTED_ORDERS_KEY, []));
      const models = (store.settings && store.settings.models) || [];
      let newest = null;
      // 订单按新到旧返回,第一个新导入的即为最新购买
      orders.forEach((order) => {
        if (order.status !== 'issued' || !order.modelConfig) return;
        const exists = models.some(m => m.tokenStore && m.tokenStore.orderNo === order.orderNo);
        if (exists) {
          imported.add(order.orderNo);
          return;
        }
        if (imported.has(order.orderNo)) return;
        const saved = mutations.addModel(order.modelConfig);
        imported.add(order.orderNo);
        if (!newest) newest = { saved, type: order.modelConfig.type || 'text' };
      });
      writeJson(IMPORTED_ORDERS_KEY, Array.from(imported));

      if (newest) {
        mutations.setActiveModelByType(newest.saved.id, newest.type);
        return newest.saved;
      }
      return null;
    } catch (e) {
      console.warn('[token-store] sync cloud orders failed:', e);
      return null;
    } finally {
      syncing = null;
    }
  })();
  return syncing;
}
